// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FM-z","twoColumnImage":"GM-z"};